document.addEventListener('DOMContentLoaded', () => {
  const stickyContainers = document.querySelectorAll('.sticky-atc');

  if (!('IntersectionObserver' in window) || stickyContainers.length === 0) {
    return;
  }

  // Mobile breakpoint
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  if (!isMobile()) {
    return;
  }

  // Allow sticky ATC to work on any page with the markup

  stickyContainers.forEach((container) => {
    const targetSelector = container.dataset.target;
    const targetButton = document.querySelector(targetSelector);
    if (!targetButton) {
      return;
    }

    const stickyButton = container.querySelector('button');
    if (!stickyButton) return;

    const syncButtonState = () => {
      // Copy classes from main button for consistent styling
      stickyButton.className = targetButton.className;
      stickyButton.disabled = targetButton.disabled;
      stickyButton.innerHTML = targetButton.innerHTML;
    };

    syncButtonState();

    // Click -> proxy to main button
    stickyButton.addEventListener('click', () => {
      if (targetButton.disabled) return;
      targetButton.click();
    });

    // Observe attribute/content changes of main button
    const mutationObserver = new MutationObserver(syncButtonState);
    mutationObserver.observe(targetButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    // Intersection observer to toggle visibility
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          container.classList.remove('active');
        } else {
          container.classList.add('active');
        }
      });
    });

    io.observe(targetButton);
  });
}); 